/**
 * WARNING: This file is auto-generated. Please do not modify it.
 *
 * If you need to make changes, please see the README.md file in the root of this repository.
 */

import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { Controller } from '../Controller';

import {
  PostV2RolesBody,
  DeleteV2RolesBody,
  PostV2RolesResponse,
} from '../types';

export class RoleController extends Controller {
  async postV2Roles<
    T extends PostV2RolesResponse,
    D,
    C extends PostV2RolesBody
  >(
    body: C,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      '/v2/roles',
      body,
      axiosConfig
    );
  }

  async deleteV2Roles<T, D, C extends DeleteV2RolesBody>(
    axiosConfig?: AxiosRequestConfig<C> | undefined,
    body?: C
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.delete<T, AxiosResponse<T, D>, C>('/v2/roles', {
      ...axiosConfig,
      data: body,
    });
  }
}
